module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_1024.e5398930.jpg";